import { useEffect, useState } from 'react';
import { leiderschapApi } from '../api';
import type { LeadershipMember } from '../types';

/** Org users met effectieve Leiderschap-toegang, server-side gefilterd
 * (bij een vertrouwelijke vergadering alleen wie die vergadering mag zien).
 * Bewust niet /api/team: dat toont alle gebruikers van de organisatie. */
export default function useLeadershipMembers(meetingId?: string) {
  const [members, setMembers] = useState<LeadershipMember[]>([]);

  useEffect(() => {
    let active = true;
    leiderschapApi
      .listLeadershipMembers(meetingId)
      .then((data) => {
        if (active) setMembers(data);
      })
      .catch(() => {
        if (active) setMembers([]);
      });
    return () => {
      active = false;
    };
  }, [meetingId]);

  return members;
}
